export function dateDifIgnoreWeekends(start = null, end) {
  const s = start ? new Date(start) : new Date();
  const e = new Date(end);
  s.setHours(12, 0, 0, 0);
  e.setHours(12, 0, 0, 0);
  // @ts-ignore
  const totalDays = Math.round((e - s) / 8.64e7);
  const wholeWeeks = (totalDays / 7) | 0;

  let days = wholeWeeks * 5;
  if (totalDays % 7) {
    s.setDate(s.getDate() + wholeWeeks * 7);

    while (s < e) {
      s.setDate(s.getDate() + 1);

      if (s.getDay() != 0 && s.getDay() != 6) {
        ++days;
      }
    }
  }
  return Math.sign(totalDays) === -1 ? totalDays : days;
}
